module.exports = __webpack_public_path__ + "static/media/IMG_2750.7717cb41.JPG";